module.exports = __webpack_public_path__ + "img/contract-template-operational-manual.svg";